import axios from 'axios'
import qs from 'qs'

type PartnerProps = {
  partnername: string
  logo: string
  partnerdescription: string
  mobile: string
  phone: string
  email: string
  website: string
}

const template = document.createElement('template')
template.innerHTML = `

<section class="partner-row">
<div class="container">
  <div class="row">
    <div class="col-lg-3 partner-logo-box">
      <img src="" class="img-fluid card-img-top js-partner-logo" />
      <h5 class="js-partner-name"></h5>
    </div>
    <div class="col-lg-3 offset-lg-1">
      <p class="small js-partner-description"></p>
    </div>
    <div class="col-lg-4 offset-lg-1">
      <div class="contact-info small dcg-construction">
          <div class="js-partner-phone mb-3"><img src="/fileadmin/partner/phone.svg" class="w-32 mr-3" /><span class="d-inline-block ms-2"></span></div>
          <div class="js-partner-mobile mb-3"><img src="/fileadmin/partner/mobile.svg" class="w-32 mr-3" /><span class="d-inline-block ms-2"></span></div>
          <div class="js-partner-email mb-3"><img src="/fileadmin/partner/envelope.svg" class="w-32 mr-3" /><span class="d-inline-block ms-2"></div>
          <div class="js-partner-website mb-3"><img src="/fileadmin/partner/wikis.svg" class="w-32 mr-3" /><span class="d-inline-block ms-2"></span></p>
      </div>
    </div>
  </div>
</div>
</section>
`

class PartnerCard extends HTMLElement {
  constructor(
    partnernname: string,
    logo: string,
    partnerdescription: string,
    mobile: string,
    phone: string,
    email: string,
    website: string
  ) {
    super()
    this.appendChild(template.content.cloneNode(true))
    this.classList.add('partner-card', 'w-100')
    const partnerNameElement = this.querySelector(
      '.js-partner-name'
    ) as HTMLElement
    const partnerLogoElement = this.querySelector(
      '.js-partner-logo'
    ) as HTMLImageElement
    const partnerDescriptionElement = this.querySelector(
      '.js-partner-description'
    ) as HTMLElement
    const partnerPhoneElement = this.querySelector(
      '.js-partner-phone span'
    ) as HTMLElement
    const partnerMobileElement = this.querySelector(
      '.js-partner-mobile span'
    ) as HTMLElement
    const partnerEmailElement = this.querySelector(
      '.js-partner-email span'
    ) as HTMLElement
    const partnerWebsiteElement = this.querySelector(
      '.js-partner-website span'
    ) as HTMLElement

    partnerNameElement.innerText = this.getAttribute('name') || partnernname
    if (this.getAttribute('logo') || logo) {
      partnerLogoElement.src = this.getAttribute('logo') || logo
    } else {
      this.querySelector('.js-partner-logo')?.remove()
    }
    if (this.getAttribute('partnerdescription') || partnerdescription) {
      partnerDescriptionElement.innerHTML =
        this.getAttribute('partnerdescription') || partnerdescription
    } else {
      partnerDescriptionElement.remove()
    }
    if (this.getAttribute('phone') || phone) {
      partnerPhoneElement.innerText = this.getAttribute('phone') || phone
    } else {
      this.querySelector('.js-partner-phone')?.remove()
    }
    if (this.getAttribute('mobile') || mobile) {
      partnerMobileElement.innerText = this.getAttribute('mobile') || mobile
    } else {
      this.querySelector('.js-partner-mobile')?.remove()
    }
    if (this.getAttribute('email') || email) {
      partnerEmailElement.innerText = this.getAttribute('email') || email
    } else {
      this.querySelector('.js-partner-email')?.remove()
    }
    if (this.getAttribute('website') || website) {
      partnerWebsiteElement.innerText = this.getAttribute('website') || website
    } else {
      this.querySelector('.js-partner-website')?.remove()
    }

    // check if all the contact-info divs are empty
    const contactInfoDiv = this.querySelector('.contact-info')
    if (!contactInfoDiv) {
      return
    }
    const isEmpty = Array.from(contactInfoDiv.children).every((child) => {
      const childContent = child.querySelector('span')?.textContent
      return !childContent
    })
    if (isEmpty) {
      contactInfoDiv.remove()
    }
  }
  connectedCallback() {
    this.render()
  }

  render() {}
}

document.addEventListener('DOMContentLoaded', () => {
  const findPartnerFrame = document.getElementById('partner-hidden')
  const loadingWrap = document.querySelector('.loading-wrap')

  if (findPartnerFrame) {
    // sort all countrys with umlauts

    // Select the country divs
    let countryDivs = document.querySelectorAll('#ap-filter .select-items div')

    // Get the country names and sort them
    let countryList = Array.from(countryDivs).map((div) => div.textContent)
    countryList.sort((a, b) => a.localeCompare(b, 'de'))

    // Replace the old list with the new sorted one
    for (let i = 0; i < countryDivs.length; i++) {
      countryDivs[i].textContent = countryList[i]
    }

    // add search field to the form
    const selectItems = document.querySelector('#ap-filter .select-items')
    const searchField = document.createElement('input')

    searchField.setAttribute('type', 'text')
    searchField.setAttribute('name', 'tx_ytdcg_partner[search]')
    searchField.setAttribute('placeholder', 'Suche ...')
    searchField.classList.add('form-control')
    if (selectItems) {
      selectItems.insertBefore(searchField, selectItems.firstChild)
    }

    // if we click inside the search field we dont want to close the select box
    searchField.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    searchField.addEventListener('keydown', function (event: KeyboardEvent) {
      if (event.key === 'Enter') {
        event.preventDefault()
      }
    })

    // if we type in the search field we want to filter the select box but only the first letters
    searchField.addEventListener('keyup', (e) => {
      const searchValue = (e.target as HTMLInputElement).value
      const selectItems = document.querySelectorAll(
        '#ap-filter .select-items div'
      )
      selectItems.forEach((item) => {
        const itemText = item.textContent?.toLowerCase()
        if (itemText?.startsWith(searchValue.toLowerCase())) {
          item.classList.remove('d-none')
        } else {
          item.classList.add('d-none')
        }
      })
    })

    const partnerCardWrap = document.querySelector('.partner-card-wrap')

    document.querySelectorAll('.select-items div').forEach((div) =>
      div.addEventListener('click', () => {
        formAction()
      })
    )

    const formAction = () => {
      const form = document.getElementById('findPartner') as HTMLFormElement
      const actionURL = form.action
      loadingWrap?.classList.add('loading')
      // remove all cards
      if (document.querySelectorAll('.partner-card').length > 0) {
        document
          .querySelectorAll('.partner-card')
          .forEach((partner) => partner.remove())
      }

      // getting form data
      const data = new FormData(form)
      // preparing data - also setting ajax to true - if not we reject it in ContactController.php
      const formData = {
        tx_ytdcg_partner: {
          ajax: true,
          country: data.get('tx_ytdcg_partner[country]'),
        },
      }

      axios
        .post(actionURL, qs.stringify(formData))
        .then((response) => {
          // Making Card Elements from response
          response.data.forEach((x: PartnerProps) => {
            if (partnerCardWrap) {
              partnerCardWrap.append(
                new PartnerCard(
                  x.partnername,
                  x.logo,
                  x.partnerdescription,
                  x.mobile,
                  x.phone,
                  x.email,
                  x.website
                )
              )
            }
          })
        })
        .catch((error) => console.log(error))
        .finally(() => {
          // scroll to section
          const partnerListDiv = document.getElementById('partner-hidden')
          if (partnerListDiv && loadingWrap) {
            partnerListDiv.classList.add('show')
            setTimeout(() => {
              var scrolledY = window.scrollY
              window.scroll(0, partnerListDiv.offsetTop - scrolledY)
              loadingWrap.classList.remove('loading')
            }, 500)
          }
        })
    }
  }

  // to the dom
  window.customElements.define('partner-card', PartnerCard)
})

// search fields

const searchInput: HTMLInputElement | null = document.getElementById(
  'search-input'
) as HTMLInputElement
const selectItems: HTMLElement | null = document.querySelector(
  '.select-items'
) as HTMLElement
const options: HTMLElement[] = Array.from(
  selectItems?.children || []
) as HTMLElement[]

if (searchInput && selectItems) {
  searchInput.addEventListener('input', function () {
    const searchTerm: string = searchInput.value.toLowerCase()

    options.forEach(function (option: HTMLElement) {
      const text: string = option.textContent?.toLowerCase() || ''
      if (text.indexOf(searchTerm) !== -1) {
        option.style.display = ''
      } else {
        option.style.display = 'none'
      }
    })
  })
}
